import React, { useEffect } from "react";
import "./App.css";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import Home from "./pages/Home/Home";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsCondition from "./pages/TermsCondition";
import MobilePrivacyPolicy from "./pages/Mobile/PrivacyPolicy";
import MobileTermsCondition from "./pages/Mobile/TermsConditions";
import ContactUs from "./pages/ContactUs";
import { ToastContainer } from "react-toastify";
import ScrollToTop from "./utils/ScrollToTop";
import AOS from "aos";
import "aos/dist/aos.css";

const App = () => {
  useEffect(() => {
    // Initialize AOS
    AOS.init({
      duration: 1000,
      easing: "ease-in-out",
      once: true,
    });
  }, []);

  return (
    <>
      <Router>
        {/* <Router basename="web"> */}
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-condition" element={<TermsCondition />} />
          <Route
            path="/privacy-policy-mobile"
            element={<MobilePrivacyPolicy />}
          />
          <Route
            path="/terms-condition-mobile"
            element={<MobileTermsCondition />}
          />
          <Route path="/contact-us" element={<ContactUs />} />
        </Routes>
      </Router>
      <ToastContainer />
    </>
  );
};

export default App;
